<div class="container">
  <mat-card>
    <div class="layout-row responsive-column gap-20px">
      <div class="flex-50">
        <mat-nav-list>
          <mat-list-item [routerLink]="['ranges']" *LOSxHasPermission="'READ_DELINQUENCY_RANGE'">
            <mat-icon matListIcon [routerLink]="['ranges']">
              <fa-icon icon="building" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine [routerLink]="['ranges']">{{ 'labels.heading.Manage Delinquency Ranges' | translate }}</h4>
            @if (!arrowBooleans[0]) {
              <fa-icon (click)="arrowBooleansToggle(0); $event.stopPropagation()" icon="arrow-down" size="md"></fa-icon>
            }
            @if (arrowBooleans[0]) {
              <fa-icon (click)="arrowBooleansToggle(0); $event.stopPropagation()" icon="arrow-up" size="md"></fa-icon>
            }
            @if (arrowBooleans[0]) {
              <p matLine [routerLink]="['ranges']">
                {{ 'labels.text.Define delinquency day ranges' | translate }}
              </p>
            }
          </mat-list-item>
        </mat-nav-list>
      </div>

      <div class="flex-50">
        <mat-nav-list>
          <mat-list-item [routerLink]="['buckets']" *LOSxHasPermission="'READ_DELINQUENCY_BUCKET'">
            <mat-icon matListIcon [routerLink]="['buckets']">
              <fa-icon icon="building" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine [routerLink]="['buckets']">{{ 'labels.heading.Manage Delinquency Buckets' | translate }}</h4>
            @if (!arrowBooleans[1]) {
              <fa-icon (click)="arrowBooleansToggle(1); $event.stopPropagation()" icon="arrow-down" size="md"></fa-icon>
            }
            @if (arrowBooleans[1]) {
              <fa-icon (click)="arrowBooleansToggle(1); $event.stopPropagation()" icon="arrow-up" size="md"></fa-icon>
            }
            @if (arrowBooleans[1]) {
              <p matLine [routerLink]="['buckets']">
                {{ 'labels.text.Define delinquency bucket as set of ranges' | translate }}
              </p>
            }
          </mat-list-item>
        </mat-nav-list>
      </div>
    </div>
  </mat-card>
</div>
